export default __webpack_public_path__ + "static/media/rules.e72ce597.png";